import Head from 'next/head'
import HeroSection from '../../containers/memberships/hero-section'

export default function Memberships() {
  return (
    <>
      <Head>
        <title>Select the Membership you wish to register with</title>
        <meta name='description' content='Select the Membership you wish to register with' />
      </Head>

      <HeroSection />

      <style jsx>{`
        .container {
          max-width: 193rem;
          width: 100%;
          margin: 0 auto;
          padding: 0 4rem;
        }

        .infoSection {
          max-width: 153.2rem;
          width: 100%;
          margin: 5.3rem auto 8rem;
        }

        .features {
          max-width: 164.8rem;
          margin: 0 auto 8.5rem;
        }

        .location {
          margin: 0 0 20.8rem;
          padding: 4.2rem 0 0;
          background: var(--secondary-input-bg);
        }

        .purchaseInfo {
          min-height: 100rem;
          margin: 0 auto;
          padding: 0 0 15rem;
        }

        .ctaSection {
          margin: 10rem 0 8.3rem;
        }

        @media (max-width: 1024px) {
          .container {
            max-width: 100%;
            padding: 0 1.1rem;
          }

          .infoSection {
            margin: 1.5rem auto 2.7rem;
          }

          .features {
            margin: 0 auto 3.6rem;
          }

          .location {
            margin: 0 0 2.6rem;
            padding: 2.6rem 0 0;
          }

          .purchaseInfo {
            min-height: 46rem;
            padding: 0;
          }

          .ctaSection {
            margin: 2.3rem 0 0rem;
          }
        }
      `}</style>
    </>
  )
}

Memberships.getInitialProps = () => ({
  namespacesRequired: ['common'],
})
